import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { NotificationService } from './../../../services/notification.service';
import { WebService } from './../../../services/web.service';
import { Component, Input, OnInit } from '@angular/core';
import { LoginInfoProvider } from '../../../ev-dal/login-info.provider';



@Component({
  selector: 'app-gpa',
  templateUrl: './gpa.component.html',
  styleUrls: ['./gpa.component.scss']
})
export class GpaComponent implements OnInit {

  @Input() studentProfileId: any;

  profileId: number;
  loader = false;
  weightedGPA = '';
  unweightedGPA = '';
  unknownGPA = true;

  constructor(
    private webService: WebService,
    private notificationService: NotificationService,
    private authService: LoginInfoProvider,
    private _commonDataSharedService: CommonDataSharedService,
  ) { }

  ngOnInit() {
    this.profileId = this.studentProfileId || this.authService.userId;
    this.getGPA();
  }

  // get GPA score from the student profile
  getGPA() {
    const data = {
      studentUserId: this.profileId,
      partnerId: this.authService.partnerId
    };
    this.webService.post('student/getGPA', data)
      .subscribe(
        (response: any) => {
          this._setGPA(response);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching student profile');
        });
  }

  // save GPA score to the student profile
  saveGPA() {
    const data = {
      partnerId: this.authService.partnerId,
      studentUserId: this.profileId,
      gpa: {
        weighted: this.weightedGPA,
        unweighted: this.unweightedGPA,
        unknown: this.unknownGPA
      }
    };
    this.loader = true;
    this.webService.post('student/setGPA', data)
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'GPA saved successfully!');
          this._commonDataSharedService.updateCoachStudentDetail.next();
          this._commonDataSharedService.studentProfileUpdate.next();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while GPA saving');
        });
  }

  // inner methods
  UnknownGPA() {
    if (!this.unknownGPA) {
      this.weightedGPA = '';
      this.unweightedGPA = '';
    }
  }

  _setKnownGPA(value) {
    this.unknownGPA = false;
    if ( value > 5) {
      this.notificationService.show('info', 'Max value of weighted GPA is 5.0');
      this.weightedGPA = '';
    }
    if (value < 0) {
      this.notificationService.show('info', 'Min value of weighted GPA is 0');
      this.weightedGPA = '';
    }
  }

  _setUnKnownGPA(value) {
  this.unknownGPA = false;
  if ( value > 4) {
    this.notificationService.show('info', 'Max value of Unweighted GPA is 4.0');
    this.unweightedGPA = '';
  }
  if (value < 0) {
    this.notificationService.show('info', 'Min value of Unweighted GPA is 0');
    this.unweightedGPA = '';
  }
 }
  // NEEDFIX: refactor data processing after response format changing
  _setGPA (data) {
    this.unknownGPA = data.gpa && data.gpa[0] && data.gpa[0].value ? data.gpa[0].value === 'True' : false;
    this.weightedGPA = data.gpa && data.gpa[1] && data.gpa[1].value ? (Number(data.gpa[1].value)).toFixed(2) : '';
    this.unweightedGPA = data.gpa && data.gpa[2] && data.gpa[2].value ? (Number(data.gpa[2].value)).toFixed(2) : '';
  }
}
